import { ILayouts } from "core";
import default_layout from "./default_layout";

export const layouts: ILayouts = {
  default_layout,
};
